import { createBrowserRouter } from "react-router-dom";
import { Root } from "../components/root/Root";
import { clientRoutes } from "../screens/clients/ClientRoutes";
import { feedbackRoutes } from "../screens/feedbacks/feedbackRoutes";
import { orderRoutes } from "../screens/orders/orderRoutes";
import { sessionRoutes } from "../screens/sessions/sessionRoutes";
import { ErrorPage } from "../components/errors/ErrorPage";
import { leadsRoutes } from "../screens/leads/leadsRoutes";
import { treatmentRoutes } from "../screens/treatments/treatmentRoutes";
import { evaluationRoutes } from "../screens/evaluations/evaluationRoutes";
import { relativesRoutes } from "../screens/relatives/relativesRoutes";
import { tasksRoutes } from "../screens/tasks/tasksRoutes";
import { candidatesRoutes } from "../screens/candidates/candidatesRoutes";
import { nativeDashboardsRoutes } from "../screens/native-dashboards/nativeDashboardsRoutes";
import { withAuthenticatedRoute } from "./withAuthenticatedRoute";
import { Login } from "../screens/login/Login";
import { customerSurveyRoutes } from "../screens/customer-surveys/customerSurveyRoutes";
import { bankTransactionsRoutes } from "../screens/bank-transactions/bankTransactionsRoutes";
import { partnersRoutes } from "../screens/partners/partnersRoutes";
import { templatesRoutes } from "../settings-screens/templates/templatesRoutes";
import { callsRoutes } from "../screens/calls/callsRoutes";
import { schedulesRoutes } from "../settings-screens/schedules/schedulesRoutes";
import { staffRoutes } from "../screens/staff/staffRoutes";
import { processesRoutes } from "../screens-processes/processesRoutes";
import { staffAgreementsRoutes } from "../settings-screens/staff-agreements/staffAgreementsRoutes";
import { neurofeedbackSessionRoutes } from "../screens/neurofeedback-zscore-sessions/neurofeedbackSessionRoutes";
import { protocolRoutes } from "../screens/protocols/protocolRoutes";
import { neurofeedbackFeedbackTypesRoutes } from "../settings-screens/neurofeedback-feedback-types/neurofeedbackFeedbackTypesRoutes";
import { clinicsNfbCapacityBlocksRoutes } from "../settings-screens/clinics-nfb-capacity-blocks/clinicsNfbCapacityBlocksRoutes";
import { Sandbox } from "../sandbox/Sandbox";
import { categoriesParentRoutes } from "../settings-screens/processes-categories-parent/categoriesParentRoutes";
import { categoriesChildRoutes } from "../settings-screens/processes-categories-child/categoriesChildRoutes";
import { staffKpisRoutes } from "../settings-screens/staff-kpis/staffKpisRoutes";
import { userRoutes } from "../screens/user/userRoutes";
import { eegRecordingRoutes } from "../screens/eeg-recording/eegRecordingRoutes";
import { eegDataRoutes } from "../screens/eeg-data/eegDataRoutes";
import { staffWeeklyHoursRoutes } from "../settings-screens/staff-weekly-hours/staffWeeklyHoursRoutes";
import { staffRemunerationRoutes } from "../settings-screens/staff-remunerations/staffRemunerationRoutes";
import { reservedSlotsRoutes } from "../screens/reserved-slots/reservedSlotsRoutes";
import { operationalCentersRoutes } from "../screens/operational-centers/operationalCentersRoutes";
import { psyEvaluationsRoutes } from "../screens/psy-evaluations/psyEvaluationsRoutes";
import { gapsRoutes } from "../screens/gaps/gapsRoutes";
import { scheduledTasksRoutes } from "../screens/scheduled-tasks/scheduledTasksRoutes";
import { dynamicTasksRoutes } from "../screens/dynamic-tasks/dynamicTasksRoutes";

const routesToAuthenticate = [
    clientRoutes,
    feedbackRoutes,
    orderRoutes,
    sessionRoutes,
    leadsRoutes,
    treatmentRoutes,
    evaluationRoutes,
    relativesRoutes,
    tasksRoutes,
    candidatesRoutes,
    nativeDashboardsRoutes,
    customerSurveyRoutes,
    bankTransactionsRoutes,
    partnersRoutes,
    templatesRoutes,
    neurofeedbackFeedbackTypesRoutes,
    clinicsNfbCapacityBlocksRoutes,
    callsRoutes,
    schedulesRoutes,
    staffRoutes,
    processesRoutes,
    staffAgreementsRoutes,
    staffRemunerationRoutes,
    neurofeedbackSessionRoutes,
    protocolRoutes,
    categoriesParentRoutes,
    categoriesChildRoutes,
    staffKpisRoutes,
    userRoutes,
    eegRecordingRoutes,
    eegDataRoutes,
    staffWeeklyHoursRoutes,
    reservedSlotsRoutes,
    operationalCentersRoutes,
    psyEvaluationsRoutes,
    gapsRoutes,
    scheduledTasksRoutes,
    dynamicTasksRoutes,
    [
        {
            path: "sandbox",
            element: <Sandbox />,
        },
    ],
];

//@ts-ignore
const authenticateRoutes = withAuthenticatedRoute(routesToAuthenticate);

export const router = createBrowserRouter([
    {
        path: "/",
        element: <Root />,
        errorElement: <ErrorPage />,
        children: authenticateRoutes,
    },

    {
        path: "/login",
        element: <Login />,
    },
    {
        path: "/login-impersonate",
        element: <Login isImpersonation />,
    },
]);
